module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-hover-bg-left.c0b03bde.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-hover-bg-left.png
// module id = 3487
// module chunks = 11